export const currencySymbolRenderer = (value, data, account = {}, config = {}) => {
  const symbol = new Intl.NumberFormat(undefined, { style: 'currency', currency: data.currency, currencyDisplay: 'code' }).formatToParts(value).find(x => x.type === 'currency'); 
  return symbol && symbol.value;
};
/* Release 3.2 - 9.1Req - Starts */
export const currencySymbolRendererForSimulation = (value, data, account = {}, config = {}) => {
  const symbol = new Intl.NumberFormat(undefined, { style: 'currency', currency: data.currency, currencyDisplay: 'code' }).formatToParts(value).find(x => x.type === 'currency'); 
  return symbol && symbol.value + ' ';
};
/* Release 3.2 - 9.1Req - Ends */